/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Sync_Exportable_HintInputs */

const cs_tasks_sync_exportable_hint = /** @type {(inputs: Tasks_Sync_Exportable_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do předplaceného kalendáře se dostanou jen exportovatelné úkoly.`)
};

const en_tasks_sync_exportable_hint = /** @type {(inputs: Tasks_Sync_Exportable_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only exportable tasks appear on your subscribed calendar.`)
};

/**
* | output |
* | --- |
* | "Only exportable tasks appear on your subscribed calendar." |
*
* @param {Tasks_Sync_Exportable_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_sync_exportable_hint = /** @type {((inputs?: Tasks_Sync_Exportable_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Sync_Exportable_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_sync_exportable_hint(inputs)
	return cs_tasks_sync_exportable_hint(inputs)
});